<template>
    <div class="logistics-tabs">
        <div class="tabs container">
            <div class="tabs-list">
                <ul>
                    <li
                        v-for="(item,index) in innerMenu"
                        v-bind:key="index"
                        v-bind:class="{on: item.isCur}"
                        class="li"
                    >
                        <router-link :to="{name:item.name}" class="link">{{item.title}}</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'tabs',
    props:{innerMenu:Array},
    methods: {
        changeTab(tabname) {
            this.innerMenu.map(item => {
                if (item.name === tabname) {
                    item.isCur = true;
                } else {
                    item.isCur = false;
                }
            });

            if (tabname === this.outerTab) {
                this.innerMenu[0].isCur = true;
            }
        }
    },
    mounted() {
        const tabname = this.$route.name || this.innerMenu[0].name;
        this.changeTab(tabname);
    },
    watch: {
        $route: function() {
            const tabname = this.$route.name || this.innerMenu[0].name;
            this.changeTab(tabname);
        }
    }
};
</script>
<style lang="less">
.logistics-tabs{
    border-bottom: #f6f6f6 solid 1px;
    .tabs-list {
        margin: 0 auto;
    }
    .on {
        background: #ff8b00;
        a {
            color: #ffffff;
        }
    }
    .tabs {
        height: 0.9rem;
        ul {
            display: flex;
        }
    }
    .li {
        flex: 1;
        text-align: center;
        line-height: 0.9rem;
        font-size: 18px;
        color: #333333;
        a {
            display: block;
        }
    }
}

@media screen and (min-width: 840px) and (max-width: 1079px) {
    .logistics-tabs .li {
        font-size: 16px;
    }
}

@media screen and (min-width: 481px) and (max-width: 839px) {
    .logistics-tabs .li {
        font-size: 14px;
    }
}
@media screen and (max-width: 480px) {
    .logistics-tabs{
        .on {
            border-bottom: #ff8b00 0.02rem solid;
            background: #ffffff;
            a {
                color: #000000;
            }
        }
        .tabs {
            height: 0.5rem;
        }
        .li {
            line-height: 0.48rem;
            font-size: 12px;
        }
    }
}
</style>